






import {Component} from "vue-property-decorator"
import Vue from "vue"
import {ActiveInject} from "@/support/reactive"

@Component({})
export default class Injected1 extends Vue {
    @ActiveInject({from: 'jds.test.provide1', default: 'def'}) val1!: string;
    @ActiveInject({from: 'jds.test.provide2', default: ''}) val2!: string;
}
